import React from "react";

const Stat_Gathering_Data = () => {
  return (
    <div>
      <h1>Stat Gathering Data</h1>
    </div>
  );
};

export default Stat_Gathering_Data;
